import { LegalLayout } from '@/components/legal/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      description="The terms that govern your use of the Yaw CTV (Yaw Media Group) website at yawctv.com."
      path="/terms"
      updated="June 18, 2026"
    >
      <p>
        These Terms of Service ("Terms") govern your use of <a href="https://www.yawctv.com">yawctv.com</a>{' '}
        (the "Site"), operated by Yaw Media Group under the Yaw CTV brand ("we," "us," or "our"). By
        accessing or using the Site, you agree to these Terms. If you do not agree, please do not use
        the Site.
      </p>

      <h2>About the Site</h2>
      <p>
        The Site provides information about our digital marketing and advertising services, including
        media buying, OTT/CTV, programmatic, geo-targeted, and social campaigns. Content on the Site
        is for general informational purposes and does not constitute an offer, guarantee of results,
        or professional advice. Any engagement for services is governed by a separate written
        agreement.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Do not use the Site for any unlawful purpose or in violation of these Terms.</li>
        <li>Do not attempt to disrupt, overload, or gain unauthorized access to the Site or its systems.</li>
        <li>Do not scrape, harvest, or misuse data, or submit false, abusive, or infringing content.</li>
      </ul>

      <h2>Form submissions</h2>
      <p>
        When you submit information through our forms, you represent that it is accurate and that you
        are authorized to provide it. Information you submit is handled in accordance with our{' '}
        <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>Intellectual property</h2>
      <p>
        The Site and its content — including text, graphics, logos, and the Yaw CTV name and marks —
        are owned by Yaw Media Group or its licensors and are protected by applicable laws. You may
        not copy, reproduce, or use them without our prior written permission.
      </p>

      <h2>Disclaimers</h2>
      <p>
        The Site is provided "as is" and "as available" without warranties of any kind, whether
        express or implied, including merchantability, fitness for a particular purpose, and
        non-infringement. We do not warrant that the Site will be uninterrupted, error-free, or
        secure.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, Yaw Media Group will not be liable for any indirect,
        incidental, special, consequential, or punitive damages, or any loss of data, profits, or
        revenue, arising from your use of the Site.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of Florida, USA, without regard to its
        conflict-of-laws rules. Any disputes will be subject to the courts located in Florida.
      </p>

      <h2>Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Changes are effective when posted, and we will
        update the "Last updated" date above. Your continued use of the Site constitutes acceptance
        of the revised Terms.
      </p>

      <h2>Contact us</h2>
      <p>
        Yaw Media Group (Yaw CTV) — Orlando, Florida, USA. Questions about these Terms? Email{' '}
        <a href="mailto:ads@yawctv.com">ads@yawctv.com</a>.
      </p>

      <p className="text-xs">
        This page is provided for general information and does not constitute legal advice. Please
        have it reviewed by qualified counsel before relying on it.
      </p>
    </LegalLayout>
  );
}
